import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

const OBJECT_CATEGORY_OPTIONS = [
  { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE_TTFINANS.ANTIQUES', value: 'ANTIQUES', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.GLASSES', value: 'GLASSES', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.BUNAD_WITH_SILVER', value: 'BUNAD_WITH_SILVER', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.DIVING_EQUIPMENT', value: 'DIVING_EQUIPMENT', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.ELECTRONIC_EQUIPMENT', value: 'ELECTRONIC_EQUIPMENT', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.FISHING_EQUIPMENT', value: 'FISHING_EQUIPMENT', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE_TTFINANS.PHOTO_VIDEO_PRIVATE', value: 'PHOTO_VIDEO_PRIVATE', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.GOLF_EQUIPMENT', value: 'GOLF_EQUIPMENT', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.HEARING_AID', value: 'HEARING_AID', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.INSTRUMENT_AND_MUSIC_SYSTEM', value: 'INSTRUMENT_AND_MUSIC_SYSTEM', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.FUR', value: 'FUR', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.JAWERLY', value: 'JAWERLY', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.SPORTS_EQUIPMENT', value: 'SPORTS_EQUIPMENT', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.CLOCK', value: 'CLOCK', isListEmpty: true },
  { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_VALUABLES_TYPE.WEAPON', value: 'WEAPON', isListEmpty: true },
];

const INSURED_OBJECT_FIELDS = [
  {
    name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.NUMBER,
    validator: ['', [
      Validators.required
    ]]
  },
  {
    name: 'wtcValuablesValidAbroad', key: 'WTC_INSURANCE_COMPANY_ABROAD', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.BOOLEAN,
    validator: ['', [
      Validators.required
    ]]
  },
  {
    name: 'serialNumber', key: 'SERIAL_NUMBER', group: 'OBJECT_INFO',
    inputType: INPUT_TYPES_CONFIG.NUMBER,
    validator: ['']
  },
];

export const VALUABLES = {
  nickname: 'PRODUCTS.VALUABLES.shortname',
  LIST_OF_OBJECTS: ['valuablesAdditionalObjects'],
  properties: [
    INSURED_OBJECT_FIELDS[0],
    {
      name: 'objectCategory', key: 'OBJECT_CATEGORY', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: OBJECT_CATEGORY_OPTIONS
      }
    },
    {
      name: 'numberOfInsuredObjects', key: 'NUMBER_OF_INSURED_OBJECTS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      isStormValuablesObjectCountCheck: true,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.NUMBER_OF_INSURED_OBJECTS.1', value: '1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.NUMBER_OF_INSURED_OBJECTS.2', value: '2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.NUMBER_OF_INSURED_OBJECTS.3', value: '3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.NUMBER_OF_INSURED_OBJECTS.4', value: '4' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.NUMBER_OF_INSURED_OBJECTS.5', value: '5' },
        ]
      }
    },
    {
      name: 'valuablesAdditionalObjects', key: 'VALUABLES_ADDITIONAL_OBJECTS', group: 'OBJECT_INFO',
      values: INSURED_OBJECT_FIELDS.map(field => ({
        ...field,
        validator: field.validator ? [...field.validator] : field.validator
      }))
    },
    INSURED_OBJECT_FIELDS[1],
    INSURED_OBJECT_FIELDS[2],
  ],
  icon: 'valuables'
};
